import r2wc from '@r2wc/react-to-web-component';
import Header from '../../components/Header'

const EmHeader = r2wc(Header, {
  props: {
    breadcrumb: "json",
    logo: "string",
    logoSm: "string",
    logoAlt: "string",
    logoUrl: "string",
    logoTarget: "string"
  },
});
customElements.define("em-header", EmHeader);
